module.exports = __webpack_public_path__ + "img/ygfw.2fa9bbaf.jpg";